export default __webpack_public_path__ + "static/media/water2.67841e05.png";